export default __webpack_public_path__ + "images/on-line-check-in.0906d78.svg";